import { render, staticRenderFns } from "./invoice-v2.vue?vue&type=template&id=58e4dfda"
import script from "./invoice-v2.vue?vue&type=script&lang=js"
export * from "./invoice-v2.vue?vue&type=script&lang=js"
import style0 from "./invoice-v2.vue?vue&type=style&index=0&id=58e4dfda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports